// extracted by mini-css-extract-plugin
export default {"rating":"aM-z","numberOfStars":"bM-z","count":"cM-z","barGraphSpacing":"dM-z","barGraph":"eM-z"};